document.addEventListener("DOMContentLoaded", () => {

  // ⭐ Force autoplay, muted, loop, playsinline through JS
  document.querySelectorAll(".multi-collection-image-col video").forEach(video => {
    video.muted = true;
    video.loop = true;
    video.autoplay = true;
    video.playsInline = true;

    // Force play
    video.play().catch(() => {});
  });

  // ▶️ Play / Pause button
  document.querySelectorAll(".pro-with-video-btn").forEach(btn => {
    btn.addEventListener("click", function () {

      const parent = this.closest(".multi-collection-image-col");
      const video = parent.querySelector("video");

      if (!video) return;

      if (video.paused) {
        video.play();
        parent.classList.add("play-video");
      } else {
        video.pause();
        parent.classList.remove("play-video");
      }
    });
  });

  // ⛶ Fullscreen button
  document.querySelectorAll(".pro-with-video-crop-btn").forEach(btn => {
    btn.addEventListener("click", function () {

      const parent = this.closest(".multi-collection-image-col");
      const video = parent.querySelector("video");
      if (!video) return;

      if (!document.fullscreenElement) {
        video.requestFullscreen();
      } else {
        document.exitFullscreen();
      }
    });
  });

});








// custom-chnages



document.querySelectorAll('.header__inline-menu .list-menu > .parent-menu').forEach((item) => {

  const details = item.querySelector('details');
  if (!details) return;

  item.addEventListener('mouseenter', () => {
    details.open = true;
  });

  item.addEventListener('mouseleave', () => {
    details.open = false;
  });

});

$(document).ready(function(){
  $(".scent-faq-answer").hide();

  $(".scent-faq-question").on("click", function(){
    let answer = $(this).next(".scent-faq-answer");
    let icon   = $(this).find(".faq-circle");

    if(answer.is(":visible")){
        answer.stop(true,true).slideUp(300);
        icon.removeClass("filled");
    } else {
        // Optional: close others for accordion behavior
        $(".scent-faq-answer").stop(true,true).slideUp(300);
        $(".faq-circle").removeClass("filled");

        answer.stop(true,true).slideDown(300);
        icon.addClass("filled");
    }
  });
});